export interface DietType {
    id: string;
    name: string;
    description: string;
    objective: string;
}

import { dietsEn } from "./diets/diet-en";
import { dietsIt } from "./diets/diet-it";
import { dietsEs } from "./diets/diet-es";

export const diets: { [key: string]: DietType[] } = {
    en: dietsEn,
    it: dietsIt,
    es: dietsEs,
};
